import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import configApi from '../../config';

const AverageBookingValue = () => {
    const [averageValue, setAverageValue] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        axios.get(`${configApi.apiEndpoint}/api/Stats/DashboardContext`, config)
            .then(response => {
                setAverageValue(response.data.averageBookingValue || response.data.AverageBookingValue || 0);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Error fetching average booking value:', error);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="metric-card w-100 h-100">
                <div className="skeleton-circle"></div>
                <div className="metric-data gap-2">
                    <div className="skeleton-box" style={{ width: '80px', height: '28px' }}></div>
                    <div className="skeleton-box" style={{ width: '120px', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="metric-card w-100 h-100">
            <div className="metric-icon" style={{ backgroundColor: '#e8eaf6', color: '#3f51b5' }}>
                <i className="bi bi-cash-coin"></i>
            </div>
            <div className="metric-data">
                <h3 className="fw-bold m-0 text-dark">
                    {new Intl.NumberFormat('sk-SK').format(averageValue)} €
                </h3>
                <span
                    className="text-muted"
                    style={{ fontSize: '0.85rem', cursor: 'help', borderBottom: '1px dotted #ccc' }}
                    data-tooltip-id="avg-val-tooltip"
                    data-tooltip-content="Matematický priemer zárobku na jeden úspešne zrealizovaný termín."
                >
                    Priemerná hodnota termínu
                </span>
            </div>
            <Tooltip id="avg-val-tooltip" place="top" effect="solid" className="custom-tooltip" />
        </div>
    );
};

export default AverageBookingValue;
